import { ReactNode } from 'react'
import { BoxProps, HBox, Pane, VBox } from '@integration-app/ui/Layout'
import { Outlet } from 'react-router-dom'

import { ENV_CONFIG } from 'config/env'
import { css } from 'styled-system/css'

import { UsageAlert } from '../UsageAlert/UsageAlert'

const workspaceLayoutClassnames = css({
  height: '100vh',
  minHeight: '100vh',
  maxHeight: '100vh',
  width: '100vw',
  minWidth: '100vw',
  maxWidth: '100vw',
  // Overflow is hidden to prevent the workspace layout wrapper from scrolling
  // All nested panes are scrollable
  overflow: 'hidden',
  // [PL-7138] Fix bug with relatively positioned children
  position: 'relative',
  backgroundColor: 'white',
})

export function WorkspaceLayout({ children }) {
  return (
    <VBox className={workspaceLayoutClassnames}>
      {ENV_CONFIG.ENABLE_USAGE_ALERTS && <UsageAlert />}
      <Pane stretch>{children}</Pane>
    </VBox>
  )
}

export function PaneWithMainMenu({
  children,
  mainMenu,
  ...props
}: BoxProps & { mainMenu: ReactNode }) {
  return (
    <HBox {...props}>
      {mainMenu}
      <Pane stretch>{children}</Pane>
    </HBox>
  )
}
export function PaneWithSubMenu({
  children,
  subMenu,
  ...props
}: BoxProps & { subMenu?: ReactNode }) {
  return (
    <HBox {...props}>
      {subMenu}
      <Pane stretch>{children}</Pane>
    </HBox>
  )
}

export function OutletWithMainMenu({ mainMenu }: { mainMenu?: ReactNode }) {
  return (
    <PaneWithMainMenu mainMenu={mainMenu}>
      <Outlet />
    </PaneWithMainMenu>
  )
}

export function OutletWithSubMenu({ subMenu }: { subMenu?: ReactNode }) {
  return (
    <PaneWithSubMenu subMenu={subMenu}>
      <Outlet />
    </PaneWithSubMenu>
  )
}
